/**
 * The API refuses a sign-in it does not trust with a 401 whose `error.code` is one of
 * these. The web switches on the CODE (stable), never on the API's message text.
 */
export const AUTH_REJECTION_MESSAGES: Readonly<Record<string, string>> = {
  EMAIL_NOT_VERIFIED: "Your sign-in email isn't verified with Google. Contact your administrator.",
  SIGN_IN_PROVIDER_NOT_ALLOWED: 'Please sign in with your company Google account.',
  ACCOUNT_IDENTITY_MISMATCH: 'This account is linked to a different sign-in. Contact your administrator.',
};

/**
 * The user-facing message when `response` is one of those 401 rejections, else null
 * (any other status, an unknown code or an unreadable body keeps today's behaviour).
 */
export async function readAuthRejection(response: Response): Promise<string | null> {
  if (response.status !== 401) return null;
  try {
    const body = (await response.json()) as { error?: { code?: unknown } } | null;
    const code = body?.error?.code;
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call(AUTH_REJECTION_MESSAGES, code)
      ? AUTH_REJECTION_MESSAGES[code]
      : null;
  } catch {
    return null;
  }
}
